import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { TimelineItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { clampLinesSx } from "web_myplann/Shared/Utils/sxUtils";

interface TimelineItemTextProps {
	item: Pick<TimelineItemResponseDTO, "title" | "content" | "subContent">;
	unread: boolean;
}

export const TimelineItemText: FC<TimelineItemTextProps> = ({
	item,
	unread,
}) => {
	const theme = useTheme();

	return (
		<Stack flex={1} minWidth={0} gap={0.4}>
			<Typography
				fontSize={14}
				fontWeight={
					unread
						? theme.typography.fontWeightBold
						: theme.typography.fontWeightMedium
				}
				color={theme.palette.grey[900]}
				sx={clampLinesSx(1)}
			>
				{item.title}
			</Typography>
			{item.content ? (
				<Typography
					fontSize={12}
					color={theme.palette.grey[700]}
					sx={{ ...clampLinesSx(3), wordBreak: "break-word" }}
				>
					{item.content}
				</Typography>
			) : null}
			{item.subContent ? (
				<Typography
					fontSize={12}
					color={theme.palette.grey[500]}
					sx={{ ...clampLinesSx(2), wordBreak: "break-word" }}
				>
					{item.subContent}
				</Typography>
			) : null}
		</Stack>
	);
};
